// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#aw--c #aw-sl *[data-v-2015a512]{font-family:var(--font-family)!important}", ""]);
// Exports
module.exports = exports;
